exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red[data-v-acac1550]{color:#ed4014}.table[data-v-acac1550]  .el-tooltip{white-space:inherit !important}.selWidth[data-v-acac1550]{width:350px !important}.star[data-v-acac1550] .el-rate{line-height:2.5 !important}.table[data-v-acac1550]  el-image__inner,.table .el-image__placeholder[data-v-acac1550],.table .el-image__error[data-v-acac1550]{width:auto !important}.info[data-v-acac1550]{width:63%}", ""]);

// exports
